import LearningResultPage from './LearningResultPage';

export default LearningResultPage;
